/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize GeneralSocialTSocialRisk List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './GeneralSocialTSocialRiskListView';

export const mapStateToPropsGeneralSocialTSocialRiskList = mapStateToProps;
export const mapDispatchToPropsGeneralSocialTSocialRiskList =
  mapDispatchToProps;

export default connect(
  mapStateToPropsGeneralSocialTSocialRiskList,
  mapDispatchToPropsGeneralSocialTSocialRiskList
)(View);
